import { render, staticRenderFns } from "./VideoChapter.vue?vue&type=template&id=3d11d478&scoped=true"
import script from "./VideoChapter.vue?vue&type=script&lang=js"
export * from "./VideoChapter.vue?vue&type=script&lang=js"
import style0 from "./VideoChapter.vue?vue&type=style&index=0&id=3d11d478&prod&lang=scss"
import style1 from "./VideoChapter.vue?vue&type=style&index=1&id=3d11d478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d11d478",
  null
  
)

export default component.exports